import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

const NavItem = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  return (
    <li className={`relative `} onMouseEnter={()=>setIsHovered(true)} onMouseLeave={()=>setIsHovered(false)}>
      {item.link ? (
        <Link to={item.link} className={` py-8 font-semibold transition-all duration-200 ease-in-out ${isHovered ? "text-yellow-1" : "text-primario" }`}>{item.name}</Link>
      ) : (
        <a href={item.a} target="_blank" rel="noreferrer" className={`${isHovered ? "text-yellow-1" : "text-white"} bg-blue-4 py-2 px-5 rounded-lg rounded-tl-none` }>{item.name} </a>
      )}
      {item.subItems && isHovered && (
        <ul className=" bg-white absolute w-[350px] mt-5 p-5 rounded-b-lg border-primario border-t-2 flex flex-col gap-2 font-normal">
            {item.subItems.map((subItem) => (
              // <NavItem key={subItem.id} item={subItem}/>
              <Link key={subItem.id} to={subItem.link} className={`hover:text-yellow-1`}>{subItem.name}</Link>
            ))}
        </ul>
      )}
      
    </li>
  );
};

export default NavItem;
